export default __webpack_public_path__ + "static/media/05.e0a51f5d.jpg";